module.exports = __webpack_public_path__ + "img/grid-5.ab185ae9.svg";